module.exports = __webpack_public_path__ + "img/349.9c4772a1.png";